import { ICostMutation } from "services/balance/types";
import { ICashFlowForm } from "services/cash-flow/types";

export const costFormToQuery = (form: ICashFlowForm): ICostMutation => {
  const {
    settlementName,
    name,
    fileUrl,
    repayments,
    file,
    remainingNetAmount,
    ...cost
  } = {
    ...form,
    costName: form.name,
    settlementId: "0f0c35ac-7026-4332-9e21-e79c83e616f9",
    contracts: form.repaymentsFromAllContracts
      ? []
      : form.contracts.map((c) => c.id),
  };

  return cost;
};
